var _rect, _g, _g2, _rect2, _path, _path2, _g3, _ellipse, _ellipse2, _ellipse3, _g4, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsVimportillustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 134,
    viewBox: "0 0 209 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_539_118533)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 208.101,
    height: 133,
    rx: 4,
    fill: "#FCFCFD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_539_118533)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_539_118533)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 47.5,
    width: 105,
    height: 75,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 47.5,
    width: 104.118,
    height: 75,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 53.5,
    width: 5,
    height: 3.66992,
    rx: 1,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 61.1699,
    width: 5,
    height: 3.6699,
    rx: 1,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 68.8398,
    width: 5,
    height: 3.6699,
    rx: 1,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 76.5098,
    width: 5,
    height: 3.66993,
    rx: 1,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 84.1797,
    width: 5,
    height: 3.6699,
    rx: 1,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 91.8496,
    width: 5,
    height: 3.66988,
    rx: 1,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 99.5195,
    width: 5,
    height: 3.66988,
    rx: 1,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 107.189,
    width: 5,
    height: 3.66988,
    rx: 1,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 114.859,
    width: 5,
    height: 3.66988,
    rx: 1,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 53.5,
    width: 25,
    height: 3.66992,
    rx: 1,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 61.1699,
    width: 25,
    height: 3.6699,
    rx: 1,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 68.8398,
    width: 25,
    height: 3.6699,
    rx: 1,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 76.5098,
    width: 25,
    height: 3.66993,
    rx: 1,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 84.1797,
    width: 25,
    height: 3.6699,
    rx: 1,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 91.8496,
    width: 25,
    height: 3.66988,
    rx: 1,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 99.5195,
    width: 25,
    height: 3.66988,
    rx: 1,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 107.189,
    width: 25,
    height: 3.66988,
    rx: 1,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 114.859,
    width: 25,
    height: 3.66988,
    rx: 1,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 53.5,
    width: 25,
    height: 3.66992,
    rx: 1,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 61.1699,
    width: 25,
    height: 3.6699,
    rx: 1,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 68.8398,
    width: 25,
    height: 3.6699,
    rx: 1,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 76.5098,
    width: 25,
    height: 3.66993,
    rx: 1,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 84.1797,
    width: 25,
    height: 3.6699,
    rx: 1,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 91.8496,
    width: 25,
    height: 3.66988,
    rx: 1,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 99.5195,
    width: 25,
    height: 3.66988,
    rx: 1,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 107.189,
    width: 25,
    height: 3.66988,
    rx: 1,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 114.859,
    width: 25,
    height: 3.66988,
    rx: 1,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 53.5,
    width: 25,
    height: 3.66992,
    rx: 1,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 61.1699,
    width: 25,
    height: 3.6699,
    rx: 1,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 68.8398,
    width: 25,
    height: 3.6699,
    rx: 1,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 76.5098,
    width: 25,
    height: 3.66993,
    rx: 1,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 84.1797,
    width: 25,
    height: 3.6699,
    rx: 1,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 91.8496,
    width: 25,
    height: 3.66988,
    rx: 1,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 99.5195,
    width: 25,
    height: 3.66988,
    rx: 1,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 107.189,
    width: 25,
    height: 3.66988,
    rx: 1,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 114.859,
    width: 25,
    height: 3.66988,
    rx: 1,
    fill: "#EBEBEB"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_539_118533)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_539_118533)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 80.5,
    width: 105,
    height: 75.5837,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 80.5,
    width: 105,
    height: 75.5837,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 80.5H101.591V156.084H82V80.5Z",
    fill: "#17191D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.3045,
    cy: 87.7518,
    rx: 2.0428,
    ry: 2.0428,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.359,
    y: 99.293,
    width: 67.4297,
    height: 3.26849,
    rx: 1,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.359,
    y: 108.281,
    width: 67.4297,
    height: 3.26847,
    rx: 1,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.359,
    y: 117.27,
    width: 67.4297,
    height: 3.26848,
    rx: 1,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.359,
    y: 126.258,
    width: 67.4297,
    height: 3.2685,
    rx: 1,
    fill: "#EBEBEB"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 13.4375,
    width: 19.34,
    height: 19.34,
    rx: 9.67,
    fill: "#9498A3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3188 19.459H27.0213C26.7085 19.459 26.5 19.7196 26.5 19.9802V26.2352C26.5 26.548 26.7085 26.7565 27.0213 26.7565H34.3188C34.6315 26.7565 34.84 26.548 34.84 26.2352V19.9802C34.84 19.7196 34.6315 19.459 34.3188 19.459ZM29.6275 25.714H27.5425V24.6715H29.6275V25.714ZM27.5425 24.1502H29.6275V23.1077H27.5425V24.1502ZM29.6275 22.5865H27.5425V21.544H29.6275V22.5865ZM30.1488 25.714H33.7975V24.6715H30.1488V25.714ZM33.7975 24.1502H30.1488V23.1077H33.7975V24.1502ZM30.1488 22.5865H33.7975V21.544H30.1488V22.5865Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_539_118533",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 19,
    width: 9,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3188 19.459H27.0213C26.7085 19.459 26.5 19.7196 26.5 19.9802V26.2352C26.5 26.548 26.7085 26.7565 27.0213 26.7565H34.3188C34.6315 26.7565 34.84 26.548 34.84 26.2352V19.9802C34.84 19.7196 34.6315 19.459 34.3188 19.459ZM29.6275 25.714H27.5425V24.6715H29.6275V25.714ZM27.5425 24.1502H29.6275V23.1077H27.5425V24.1502ZM29.6275 22.5865H27.5425V21.544H29.6275V22.5865ZM30.1488 25.714H33.7975V24.6715H30.1488V25.714ZM33.7975 24.1502H30.1488V23.1077H33.7975V24.1502ZM30.1488 22.5865H33.7975V21.544H30.1488V22.5865Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_539_118533)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 18.9375,
    width: 8.34,
    height: 8.34,
    fill: "white"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.855,
    cy: 23.1087,
    rx: 3.51518,
    ry: 3.51688,
    fill: "#730200"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.8853,
    cy: 23.1087,
    rx: 3.51518,
    ry: 3.51689,
    fill: "#FF9C9C"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.9156,
    cy: 23.1087,
    rx: 3.51518,
    ry: 3.51689,
    fill: "#FF3631"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_539_118533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.431 13.4375H97.4312V32.3264H117.431V13.4375Z",
    fill: "#FF3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.412 16.2471V24.2084H114.447V16.2471H100.412ZM111.765 21.5572H103.141V18.9048H111.765V21.5572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.412 26.8652H114.447V28.5212C114.447 28.7844 114.342 29.0369 114.155 29.2235C113.968 29.4101 113.714 29.5156 113.45 29.517H100.412V26.8652Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.103 24.396C139.266 23.8405 139.984 22.7199 139.984 21.4482C139.984 20.693 139.728 20.0012 139.254 19.4988C138.75 18.9606 138.048 18.6758 137.225 18.6758H134.003C133.924 18.6753 133.847 18.7044 133.788 18.7572C133.729 18.8101 133.692 18.883 133.683 18.9619L133.427 21.3829C133.611 21.3882 133.794 21.3835 133.977 21.3689C134.333 21.3383 134.687 21.2766 135.032 21.1845C135.149 21.1532 135.262 21.1167 135.375 21.0783L135.487 20.0031C135.489 19.9898 135.494 19.9771 135.502 19.9664C135.51 19.9556 135.52 19.9471 135.533 19.9419C135.545 19.9366 135.558 19.9347 135.572 19.9363C135.585 19.938 135.597 19.9431 135.608 19.9513L137.683 21.5429C137.693 21.5502 137.7 21.5597 137.706 21.5705C137.711 21.5814 137.713 21.5933 137.713 21.6054C137.713 21.6174 137.709 21.6291 137.703 21.6397C137.698 21.6502 137.689 21.6591 137.679 21.6658L135.268 23.2575C135.257 23.2652 135.243 23.2695 135.228 23.2697C135.214 23.27 135.2 23.2662 135.188 23.2589C135.176 23.2515 135.166 23.2409 135.16 23.2282C135.153 23.2155 135.151 23.2012 135.152 23.1871L135.239 22.3615C134.819 22.4029 134.396 22.4076 133.976 22.3756C133.557 22.34 133.143 22.2626 132.74 22.1445C132.691 22.1304 132.641 22.1151 132.593 22.0997C132.574 22.0939 132.555 22.0939 132.537 22.0999C132.518 22.1059 132.503 22.1175 132.491 22.1331C132.48 22.1486 132.474 22.1674 132.474 22.1865C132.474 22.2057 132.48 22.2244 132.492 22.2399L133.214 23.2139L132.871 26.6699C132.866 26.7146 132.871 26.7598 132.885 26.8026C132.899 26.8453 132.922 26.8847 132.952 26.918C132.982 26.9513 133.019 26.9779 133.06 26.996C133.101 27.0142 133.146 27.0234 133.191 27.0232H134.611C134.69 27.0236 134.767 26.9945 134.826 26.9415C134.885 26.8885 134.922 26.8154 134.931 26.7364L135.123 24.8734C135.126 24.8417 135.141 24.8124 135.164 24.7911C135.188 24.7698 135.219 24.7581 135.251 24.7582H135.814C135.837 24.758 135.86 24.7641 135.88 24.776C135.9 24.7878 135.917 24.8049 135.928 24.8254L137.015 26.8542C137.043 26.9051 137.083 26.9476 137.133 26.9772C137.182 27.0068 137.239 27.0225 137.297 27.0225H138.965C139.02 27.0225 139.075 27.0083 139.123 26.9811C139.171 26.954 139.211 26.9149 139.239 26.8676C139.268 26.8203 139.283 26.7665 139.285 26.7113C139.286 26.6561 139.274 26.6015 139.248 26.5528L138.103 24.396Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_539_118533",
    x: 5,
    y: 31.5,
    width: 137,
    height: 107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.298073 0 0 0 0 0.327779 0 0 0 0 0.404167 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_539_118533"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_539_118533",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_539_118533",
    x: 66,
    y: 64.5,
    width: 137,
    height: 107.584,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.298073 0 0 0 0 0.327779 0 0 0 0 0.404167 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_539_118533"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_539_118533",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_539_118533"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 208.101,
    height: 133,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_539_118533"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 47.5,
    width: 105,
    height: 75,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_539_118533"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 80.5,
    width: 105,
    height: 75.5837,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_539_118533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18.8889,
    fill: "white",
    transform: "translate(97.4312 13.4375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsVimportillustration);
export default __webpack_public_path__ + "static/media/CSV import illustration.e6ec6e40effc037ec42df77c7b510774.svg";
export { ForwardRef as ReactComponent };